import { createRequestReducer } from "redux-request-state";

import * as actions from "./loss-reason.actions";

export const lossReasons = createRequestReducer({
    begin: actions.REQUEST_LOSS_REASONS,
    success: actions.RECEIVE_LOSS_REASONS,
    failure: actions.ERROR_LOSS_REASONS
});